import { DELETE_VEHICLE } from '../actions/vehicleActions';

const initialState = [
    {
        key: '1',
        date: '23/12/2024',
        time: '09:15',
        vehicleId: 'Y121 RTY',
        vehicleType: 'Coach',
        vehicleModel: 'Volvo B12',
        status: 'Planned',
        duration: '3h',
        supplier: 'SAP Fieldglass'
    },
    {
        key: '2',
        date: '18/12/2024',
        time: '09:15',
        vehicleId: 'YG20 ABC',
        vehicleType: 'Coach',
        vehicleModel: 'Scania K360',
        status: 'Still have Defects',
        duration: '3h',
        supplier: 'Coupa'
    }
    // More vehicles...
];

const vehicleReducer = (state = initialState, action) => {
    switch (action.type) {
        case DELETE_VEHICLE:
            return state.filter((vehicle) => vehicle.key !== action.payload);
        default:
            return state;
    }
};

export default vehicleReducer;
